import type { FormLabelProps } from '@mui/material';

import {
  SegmentedControl,
  type SegmentedControlProps,
} from '@shared/ui/segmented-control';

import { CollapseFilter } from '../collapse-filter';

type SegmentFilterProps<Value extends string> = SegmentedControlProps<Value> & {
  title: string;
  defaultOpen?: boolean;
  formLabelProps?: FormLabelProps;
};

export function SegmentFilter<Value extends string>(props: SegmentFilterProps<Value>) {
  const { title, defaultOpen, formLabelProps, ...rest } = props;

  return (
    <CollapseFilter
      title={title}
      defaultOpen={defaultOpen}
      formLabelProps={formLabelProps}
    >
      <SegmentedControl {...rest} />
    </CollapseFilter>
  );
}
